import { render, staticRenderFns } from "./approvalRecord.vue?vue&type=template&id=33b88a52&scoped=true"
import script from "./approvalRecord.vue?vue&type=script&lang=js"
export * from "./approvalRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b88a52",
  null
  
)

export default component.exports